






























import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import { ImageLayer } from "@/model/document2/page/surface/design/layer/imageLayer";

import { PathHelper } from "@/helper/pathHelper";

import ImageKeepRatioController from "./imageKeepRatioController/imageKeepRatioController.vue";
import ImageOpacityController from "./imageOpacityController/imageOpacityController.vue";
import ImageFlipController from "./imageFlipController/imageFlipController.vue";

@Component({
    components: {
        ImageKeepRatioController,
        ImageOpacityController,
        ImageFlipController
    }
})

//******************************************//
//**************** モバイル用 ****************//
//******************************************//
export default class ImageController extends Vue 
{
    @Prop() layer! : ImageLayer;

    private imageControllerType = "imageKeepRatio";

    private isActive(type)
    {
        return this.imageControllerType == type;
    }

    private changeType(type : string)
    {
        this.imageControllerType = type;
    }

    private requestRetouch()
    {
        this.$emit("doCommand", "sendNativeEvent", { message : "request_image_retouch" });
    }

    private requestTrim()
    {
        var param = {};
        param["trim"] = this.layer.isTrim ? "true" : "false";
        param["trimRect"] = "" + this.layer.trimRectNormalized.x + "," + this.layer.trimRectNormalized.y + "," + this.layer.trimRectNormalized.width + "," + this.layer.trimRectNormalized.height;
        var path = this.layer.clipShapeSvgPath;
        var match = PathHelper.matchPattern(path);
        param["clip"] = this.layer.isClip ? "true" : "false";
        param["type"] = match.pattern;
        param["corner"] = match.cornerNumber;
        this.$emit("doCommand", "sendNativeEvent", { message : "request_image_trim", parameter : param });
    }

    private onChangeLayerProperty(propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {   
        this.$emit("doCommand", "changeLayerProperty", {  
            layer : this.layer,
            propertyName : propertyName,
            value : value,
            isFinish : isFinish,
            isOnce : isOnce
        });
    }
}
